<template>
  <div class="contain">
    <div class="form-header-btn">
      <div class="header-title">疾病防控列表</div>
      <div>
        <!-- <el-button
          type="primary"
          class="sheet-btn"
          @click="downLoadFile"
          v-if="isExport"
        >
          导出
        </el-button> -->
		<el-dropdown @command="handleCommand">
		  <el-button type="primary" style="margin-right: 0.52083vw;">
		    导出 <i class="el-icon-arrow-down el-icon--right"></i>
		  </el-button>
		  <el-dropdown-menu slot="dropdown">
		    <el-dropdown-item command="company">按分公司</el-dropdown-item>
		    <el-dropdown-item command="school">按园校</el-dropdown-item>
		    <el-dropdown-item command="all">全部</el-dropdown-item>
		  </el-dropdown-menu>
		</el-dropdown>
        <el-button
          class="sheet-btn"
          @click="dialogTableVisible = true"
          v-if="isFCompare"
        >
          分公司对比
        </el-button>
      </div>
    </div>
    <!-- 表单 -->
    <el-form :model="form" onsubmit="return false" :inline="true">
      <el-form-item>
        <el-select
          v-model="form.orgId"
          clearable
          placeholder="选择所属组织"
          @change="handleCompany"
        >
          <el-option
            v-for="item in moduleCompanyOptions"
            :key="item.label"
            :label="item.name"
            :value="item.label"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="form.parkId"
          clearable
          placeholder="选择患病园校"
          :disabled="disabledPark"
          @change="handlePark"
        >
          <el-option
            v-for="item in moduleParkOptions"
            :key="item.label"
            :label="item.name"
            :value="item.label"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="form.classId"
          clearable
          placeholder="选择患病班级"
          :disabled="disabledClass"
        >
          <el-option
            v-for="item in moduleClassOptions"
            :key="item.label"
            :label="item.name"
            :value="item.label"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="form.levelValue" clearable placeholder="严重程度">
          <el-option
            v-for="item in contagionLevelList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="form.NameValue" clearable placeholder="传染病名称">
          <el-option
            v-for="item in contagionNameList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateTime"
          type="daterange"
          range-separator="～"
          value-format="yyyy-MM-dd"
          start-placeholder="开始上报日期"
          end-placeholder="结束上报日期"
          :picker-options="pickerOptions"
          class="form-date-time"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-input
          v-model.trim="form.reportName"
          placeholder="输入上报人"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="form.statusValue"
          clearable
          placeholder="选择流程状态"
        >
          <el-option
            v-for="item in contagionStatusList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="searchFun">
          查询
        </el-button>
      </el-form-item>

      <el-form-item>
        <el-button @click="resetFun" icon="el-icon-refresh-left" class="reset">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <!-- 表格 -->
    <el-table
      id="editAbletrendsTable"
      :data="tableData"
      :header-cell-style="{
        background: '#F1F4F9',
        color: '#5E6D9B',
        fontWeight: '400',
        'text-align':'center'
      }"
      show-summary
      :summary-method="getSummaries"
      v-loading="tableLoading"
      @sort-change="sortChange"
    >
      <el-table-column
        type="index"
        label="序号"
        min-width="80"
        align="center"
      ></el-table-column>
      <el-table-column prop="companyName" label="分公司" min-width="150" align="center">
        <template slot-scope="{ row }">
          <el-tooltip
            effect="light"
            popper-class="customPopper"
            :content="row.companyName"
            placement="top"
            v-if="row.companyName"
          >
            <div class="description-div">
              {{ row.companyName }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="campusName" label="患病园校" min-width="210" align="center">
        <template slot-scope="{ row }">
          <el-tooltip
            effect="light"
            popper-class="customPopper"
            :content="row.campusName"
            placement="top"
            v-if="row.campusName"
          >
            <div class="description-div">
              {{ row.campusName }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="className"
        label="患病班级"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="sickNum"
        label="患病人数"
        min-width="110"
        sortable="custom"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="level.label"
        label="严重程度"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="contagionName.label"
        label="传染病名称"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="reportName"
        label="上报人"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="reportTime"
        label="上报日期"
        min-width="170"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="feedbackTime"
        label="结束日期"
        min-width="170"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="reportStatus.label"
        label="流程状态"
        min-width="130"
        align="center"
      >
        <template slot-scope="{ row }">
          <span
            :class="
              row.reportStatus.value == '1' || row.reportStatus.value == '2'
                ? 'activeColor'
                : ''
            "
          >
            {{ row.reportStatus.label }}
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" min-width="110" align="center">
        <template slot-scope="scope">
          <el-button
            @click="handleJumplook(scope.row)"
            type="text"
            size="medium"
            v-if="isView"
          >
            查看
          </el-button>
          <el-button
            @click="handleJumpcheck(scope.row)"
            type="text"
            size="medium"
            v-if="scope.row.reportStatus.value == '1' && isApprove"
          >
            审核
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="manger-footer">
      <div class="footer-pagination">
        <el-pagination
          background
          @size-change="handleSizeChange"
          layout="total,sizes,prev,pager,next,jumper"
          :total="pagination.total"
          :page-size="pagination.size"
          @current-change="handleCurrentChangePage"
          :current-page.sync="pagination.currentPage"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 对话框 -->
    <el-dialog
      title="分公司对比"
      :visible.sync="dialogTableVisible"
      @open="handleOpenDialog"
    >
      <div class="dialog-sheetbtn">
        <el-button type="primary" class="sheet-btn" @click="downLoadFileDialog">
          导出
        </el-button>
      </div>
      <el-table
        :header-cell-style="{
          background: '#F1F4F9',
          color: '#5E6D9B',
          fontWeight: '400',
        }"
        :data="gridData.list"
        show-summary
        :summary-method="getSummariesDialog"
        @sort-change="sortChangeDialog"
      >
        <el-table-column
          type="index"
          label="序号"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          property="name"
          label="分公司"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column
          property="total"
          label="患病人数"
          sortable="custom"
          align="center"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import downloadFile from "@/utils/downloadFile";
import { getPermissionButton } from "@/utils/getUrlPermissionButtons";
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      form: {
        orgId: "",
        parkId: "",
        classId: "",
        levelValue: "",
        NameValue: "",
        beginTime: "",
        endTime: "",
        reportName: "",
        statusValue: "",
      },
      dateTime: [],
      moduleCompanyOptions: [], //所属公司下拉
      moduleClassOptions: [], // 所属班级下拉
      moduleParkOptions: [], //所属园校下拉
      contagionLevelList: [], //严重程度
      contagionNameList: [], //传染病名称
      contagionStatusList: [], //流程状态
      disabledClass: true, //是否禁用class选择框
      disabledPark: true, //是否禁用class选择框
      dialogTableVisible: false, //dialog默认不显示状态
      tableData: [], //主表格数据
      totalCount: "", //主表患病数
      gridData: [], //分公司对比
      pagination: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        size: 10, // 每页显示多少条
      },
      dialogForm: {},
      tableLoading: false, // 表格loading
      // organizationList: [],
      orderDialog: "", //弹窗排序
      permissionButtonList: [], // 权限按钮list
      columnOrder: "", //排序方式
      pickerOptions: {
        disabledDate(times) {
          return times.getTime() > Date.now();
        },
      },
      isView: false,
      isExport: false,
      isFCompare: false,
      isApprove: false,
    };
  },

  computed: {
    ...mapState({
      menuList: (state) => state.common.menuList,
      userInfo: (state) => state.userInfo,
    }),
  },

  watch: {
    permissionButtonList: {
      handler(val) {
        if (val) {
          console.log(val, "huoshifeipermissionButtonList");
          this.isView = val.indexOf("z_infectiousDisease:view") != -1;
          this.isExport = val.indexOf("z_infectiousDisease:export") != -1;
          this.isFCompare = val.indexOf("z_infectiousDisease:fCompare") != -1;
          this.isApprove = val.indexOf("z_infectiousDisease:approve") != -1;
        }
      },
      deep: true,
    },
    menuList: {
      handler(val) {
        if (val) {
          this.getPermissionButton(this.$route.path, (data) => {
            this.permissionButtonList = data;
          });
        }
      },
      deep: true,
    },
  },

  created() {
    // menulist一直在时这个方法不可缺少
    this.getPermissionButton(this.$route.path, (data) => {
      this.permissionButtonList = data;
    });
  },

  mounted() {
    this.tableLoading = true;
    // this.init();
    this.getCompanyDeptList(); //所属组织
    this.getContagionLevel(); //传染病严重程度
    this.getContagionName(); //传染病名称
    this.getContagionStatus(); //流程状态
  },
  activated(){
    this.init();
  },

  methods: {
    getPermissionButton,
    //排序
    sortChange(column) {
      // console.log(column);
      // console.log(column.prop, column.order);
      this.columnOrder = column.order;
      this.init(column.order);
    },

    /** 初始化 */
    init(order) {
      let dateTime0 = "";
      let dateTime1 = "";
      if (this.dateTime !== null) {
        dateTime0 = this.dateTime[0];
        dateTime1 = this.dateTime[1];
      }

      let params = {
        sort: order,
        flag: "headoffice",
        companyLabel: this.form.orgId,
        campusLabel: this.form.parkId,
        classLabel: this.form.classId,
        level: this.form.levelValue,
        contagionName: this.form.NameValue,
        beginTime: dateTime0,
        endTime: dateTime1,
        reportName: this.form.reportName,
        reportStatus: this.form.statusValue,
        current: this.pagination.currentPage,
        size: this.pagination.size,
      };
      this.$api.getDiseaseLog(params).then((res) => {
        this.tableLoading = false;
        if (res.data.code == 0) {
          this.tableData = res.data.data.list.records;
          this.totalCount = res.data.data.totalCount;
          this.pagination.total = res.data.data.list.total;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    //操作查看
    handleJumplook(row) {
      this.$router.push({
        path: "/diseaseReport",
        query: {
          lookId: row.id,
          lookSubStatus: "2",
        },
      });
    },

    //操作审核
    handleJumpcheck(row) {
      this.$router.push({
        path: "/diseaseReport",
        query: {
          lookId: row.id,
          lookSubStatus: "1",
        },
      });
    },

    //表尾合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        if (index === 4) {
          sums[index] = this.totalCount;
          return;
        }
      });

      return sums;
    },

    //分公司对比合计
    getSummariesDialog(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        if (index === 2) {
          sums[index] = this.gridData.total;
          return;
        }
      });

      return sums;
    },

    //查询分公司
    getCompanyDeptList() {
      let params = {
        type: "NODE_ORG",
      };
      this.$api.getCompanyDept(params).then((res) => {
        this.tableLoading = false;
        if (res.data.code == "0") {
          this.moduleCompanyOptions = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    //查询园校
    getSchoolList(valCompany) {
      let params = {
        parent: valCompany,
        type: "NODE_SCHOOL",
      };
      this.$api.getCompanyDept(params).then((res) => {
        this.tableLoading = false;
        if (res.data.code == "0") {
          this.moduleParkOptions = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    //查询班级
    getClassInfoList(valPark) {
      let params = {
        parentLabel: valPark,
      };
      this.$api.getClassInfo(params).then((res) => {
        this.tableLoading = false;
        if (res.data.code == "0") {
          this.moduleClassOptions = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    //查询分公司change事件
    handleCompany(val) {
      this.form.parkId = "";
      this.form.classId = "";
      if (val == "") {
        this.disabledPark = true;
        this.disabledClass = true;
      } else {
        this.disabledPark = false;
        this.getSchoolList(val);
      }
    },

    //查询园校change事件
    handlePark(val) {
      this.form.classId = "";
      if (val == "") {
        this.disabledClass = true;
      } else {
        this.disabledClass = false;
        this.getClassInfoList(val);
      }
    },

    // 获取字典传染病严重程度
    getContagionLevel() {
      let params = {
        type: "contagion_level",
      };
      this.$api.getDictionary(params).then((res) => {
        if (res.data.code == 0) {
          this.contagionLevelList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 获取字典传染病传染病名称
    getContagionName() {
      let params = {
        type: "contagion_name",
      };
      this.$api.getDictionary(params).then((res) => {
        if (res.data.code == 0) {
          this.contagionNameList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 获取字典流程状态
    getContagionStatus() {
      let params = {
        type: "contagion_report_status",
      };
      this.$api.getDictionary(params).then((res) => {
        if (res.data.code == 0) {
          this.contagionStatusList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    //分公司对比
    getCompareList(company, order) {
      let params = {
        flag: company,
        sort: order,
      };
      this.$api.getCompare(params).then((res) => {
        if (res.data.code == 0) {
          this.gridData = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    //分公司对比事件
    handleOpenDialog() {
      let company = "company";
      this.getCompareList(company, "");
    },

    //弹窗排序
    sortChangeDialog(column) {
      this.orderDialog = column.order || "";
      let order = column.order || "";
      let company = "company";
      this.getCompareList(company, order);
    },
	// 按类型导出
	handleCommand(type){
		if(type == 'company'){
			this.downLoadFile(1)
		}
		else if(type == 'school'){
			this.downLoadFile(2)
		}
		else if(type == 'all'){
			this.downLoadFile(3)
		}
	},
    //导出
    downLoadFile(downFlag) {
      if (this.tableData.length > 0) {
        let dateTime0 = "";
        let dateTime1 = "";
        if (this.dateTime !== null) {
          dateTime0 = this.dateTime[0];
          dateTime1 = this.dateTime[1];
        }
        //下载文件
        let url = "/contagion/report-record/export";
        let data = {
          sort: this.columnOrder,
          flag: "headoffice",
          companyLabel: this.form.orgId,
          campusLabel: this.form.parkId,
          classLabel: this.form.classId,
          level: this.form.levelValue,
          contagionName: this.form.NameValue,
          beginTime: dateTime0,
          endTime: dateTime1,
          reportName: this.form.reportName,
          reportStatus: this.form.statusValue,
          current: this.pagination.currentPage,
          size: this.pagination.size,
		  downFlag
        };

        let type = "get";

        this.tableLoading = true;
        downloadFile({ url, data, type }).then(() => {
          this.tableLoading = false;
        });
      } else {
        this.$message.warning("暂无数据，不能导出！");
      }
    },

    downLoadFileDialog() {
      if (this.gridData.list.length > 0) {
        //下载文件
        let url = "/contagion/report-record/exportCompare";
        let data = {
          flag: "company",
          sort: this.orderDialog,
        };

        let type = "get";

        this.tableLoading = true;
        downloadFile({ url, data, type }).then(() => {
          this.tableLoading = false;
        });
      } else {
        this.$message.warning("暂无数据，不能导出！");
      }
    },

    // 查询
    searchFun() {
      this.pagination.currentPage = 1;
      this.tableLoading = true;
      this.init();
    },

    // 重置
    resetFun() {
      this.form = {
        orgId: "",
        parkId: "",
        classId: "",
        levelValue: "",
        NameValue: "",
        reportName: "",
        statusValue: "",
      };

      this.disabledPark = true;
      this.disabledClass = true;

      this.dateTime = [];
      this.pagination.currentPage = 1;
      this.tableLoading = true;
      this.init();
    },

    /** 行内-查看 */
    handleCheck(row) {
      this.dialogForm = {
        type: row.type,
        title: row.title,
        remoteAddr: row.remoteAddr,
        method: row.method,
        serviceId: row.serviceId,
        time: row.time,
        createTime: row.createTime,
      };
      this.dialogVisible = true;
    },

    /** 行内-删除 */
    handleDel(row) {
      this.$confirm(`是否确认删除id为${row.id}的日志?`, {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.$api.delLog(row.id).then((res) => {
          if (res.data.code == "0") {
            this.$message.success("删除成功");
            this.tableLoading = true;
            this.init();
          }
        });
      });
    },

    /** 分页 */
    handleCurrentChangePage(val) {
      this.pagination.currentPage = val;
      this.tableLoading = true;
      this.init();
    },

    handleSizeChange(val) {
      this.pagination.size = val;
      this.tableLoading = true;
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/select_list.scss";

.contain {
  .description-div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .form-header-btn {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;

    .sheet-btn {
      background: #003685;
      box-shadow: 0px 3px 10px rgba(52, 85, 236, 0.4);
      opacity: 1;
      border-radius: 4px;
      font-size: 14px;
      color: #ffffff;
    }

    /deep/.el-button + .el-button {
      margin-left: 20px;
    }
  }

  /deep/.el-table {
    // margin-top: 14px;
  }

  /deep/.el-dialog__body {
    padding: 0 20px 30px;
  }

  .dialog-sheetbtn {
    margin: 10px 0 20px;
  }
  .form-date-time{
    width: 270px;
  }
}

.manger-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 30px;
  padding-bottom: 1px;

  .footer-left-title {
    color: #606266;
  }
  .footer-left-num {
    color: red;
  }
}

.allData {
  width: 300px;
  white-space: normal;
}

.handleData {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
